import { render, staticRenderFns } from "./PaCourseDurationSelector.vue?vue&type=template&id=f93126c2&scoped=true"
import script from "./PaCourseDurationSelector.vue?vue&type=script&lang=js"
export * from "./PaCourseDurationSelector.vue?vue&type=script&lang=js"
import style0 from "./PaCourseDurationSelector.vue?vue&type=style&index=0&id=f93126c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f93126c2",
  null
  
)

export default component.exports